import * as HttpService from "../../../../service/HttpService";

/**
 *获取终端下拉框信息
 */
export const gteTerminal = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/remoteControl/gteTerminal", params);
};

/**
 *获取终端下拉框信息
 */
export const gteRemoteControlList = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/remoteControl/gteRemoteControlList", params);
};

/**
 *控制线路开关
 */
export const jalasmart = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/remoteControl/gteRemoteControLine", params);
};

/**
 *发送短信
 */
export const verification = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/verification/sms?operationType="+params);
};
/**
 *传入手机号码发送短信
 */
export const sendSmsCode = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/wechat/EnergyCopyRegister/sms",params);
};
/**
 *传入手机号码发送短信 不带Token
 */
export const sendSmsCodeWithoutToken = (params) => {
    return HttpService.postWithoutToken(HttpService.DOMAIN + "/wechat/EnergyCopyRegister/sms",params);
};

/**
 *发送短信
 */
export const remoteControlResult = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/remoteControl/remoteControlResult", params);
};

/**
 *插入管控记录
 */
export const addControlRecord = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/alarmManage/addControlRecord", params);
};

/**
 *设置空调温度
 */
 export const setVrvAirCon = (params) => {
    return HttpService.post(HttpService.DOMAIN + "/remoteControl/operateGaeadcuAircond", params);
};





